export type PanelType = 'Side Left' | 'Side Right' | 'Hood' | 'Roof' | 'Trunk' | 'Front Bumper' | 'Rear Bumper';

export interface GraphicPanel {
  id: string;
  file: File | Blob;
  previewUrl: string;
  type: PanelType;
  base64: string;
}

export interface VehicleDetails {
  brand: string;
  model: string;
  year: string;
  version: string;
  config: string;
}

export type ScenarioMood = 'Studio' | 'Urban' | 'Paddock' | 'Exhibition';

export interface Scenario {
  id: ScenarioMood;
  name: string;
  description: string;
  prompt: string;
  imageUrl: string;
}

export interface MockupResult {
  viewName: string;
  imageUrl: string;
  storageUrl?: string;
  id: string;
}

export interface SavedProject {
  id: string;
  timestamp: number;
  vehicle: VehicleDetails;
  results: MockupResult[];
}

export enum AppStep {
  Upload = 1,
  Vehicle = 2,
  Scenario = 3,
  Generation = 4,
  Results = 5,
  Gallery = 6
}
